<template lang="pug">
div.container
  div.image-area
    img(:src="item.imagePath")
  //- お気に入りへの登録切り替え
  div.name-area
    div.heart-area
      heart(:favorited="item.favorited" :toggleAction="toggleAction")
    div.name {{item.name}}
  div.price-area
    span.unit(v-if="item.cutSale") 1Mにつき&ensp;
    span.price {{item.price}}
    span.unit &ensp;円&ensp;(税込み)
  div.caption-area
    p.color(v-if="item.color") ●色： {{item.color}}
    p.size(v-if="item.size") ●サイズ： {{item.size}}
    p(v-if="item.caption" v-html="item.caption")
    template(v-else-if="item.composition1")
      p ●素材 {{item.composition1}}
      p(v-if="item.composition2") ●素材 {{item.composition2}}
  div.button-area
    button.negative(v-if="fromFavorite" @click="$router.push('/favorite')") 一覧に戻る
    button.negative(@click="$router.push('/redirect')") 他の商品を読み取る
    button.btn-favorite(@click="$router.push('/favorite')")
      font-awesome-icon(:style="heartStyle" icon="heart")
      span &ensp;チェックした商品をみる
</template>

<script>
import moment from "moment";
import heart from "@/components/Heart";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Success",
  components: {
    heart,
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    item: {
      type: Object,
      required: true,
      jan: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      price: {
        type: Number,
        required: true
      },
      composition1: {
        type: String,
        required: true
      },
      composition2: {
        type: String,
        default: ""
      },
      color: {
        type: String,
        required: true
      },
      size: {
        type: String,
        required: true
      },
      cutSale: {
        type: Boolean,
        required: true
      },
      caption: {
        type: String,
        default: ""
      },
      imagePath: {
        type: String,
        required: true
      }
    },
    fromFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    library.add(faHeart);
    return {
      favoriteItems: JSON.parse(localStorage.getItem("favoriteItems")) || [],
      heartStyle: {
        color: "#53433e",
        stroke: "#ffffff",
        strokeWidth: "60px"
      }
    };
  },
  mounted() {
    moment.locale("ja"); // 日本語にローカライズ
    // お気に入りに登録済みか否か算出
    this.item.favorited = this.favoriteItems.some(
      item => item.jan === this.item.jan
    );
  },
  methods: {
    saveFavorites() {
      this.item.favorited = true;
      this.item.registeredDate = moment().format("YYYY-MM-DD HH:mm");
      this.favoriteItems.unshift(this.item);
      localStorage.setItem("favoriteItems", JSON.stringify(this.favoriteItems));
    },
    deleteFavorites() {
      this.item.favorited = false;
      // 配列を検索し、一致するjanの情報を削除、ストレージに保存
      this.favoriteItems.splice(
        this.favoriteItems.findIndex(item => item.jan === this.item.jan),
        1
      );
      localStorage.setItem("favoriteItems", JSON.stringify(this.favoriteItems));
    },
    toggleAction() {
      if (!this.item.favorited) {
        this.saveFavorites();
      } else {
        this.deleteFavorites();
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.image-area
  text-align: center
  margin-top: 10%
  height: 32.3vh
  padding-bottom: 8%
  img
    width: auto
    height: 100%
    border-radius: 1vh
    border: 1px solid

.name-area
  display: flex
  vertical-align: middle
  min-height: 9.5vh
  .name
    font-weight: bold
    padding-left: 3.5%
    width: 70%
  .heart-area
    padding-top: 0.7vh
    width: 15%
    /deep/ .icon-heart
      padding-left: 0.3vh
      margin-left: 66%
    /deep/ svg
      height: 137%
      width: 137% !important

.price-area
  text-align: right
  margin-top: 5%
  padding-right: 12%
  .price
    font-size: 1.4em

.caption-area
  text-align: left
  padding: 2.2vh 9vw
  p
    margin: 0

.button-area
  button
    display: block
    margin: auto
    margin-top: 5%

.btn-favorite
  align-items: center
  display: flex
  justify-content: center
  margin: auto
  border-radius: 2em
  width: 60vw
  height: 6vmax
  font-size: 2vmax
</style>
